import { Theme } from '@mui/material';
import { ADD_PRODUCT_ROW_BOTTOM_SPACING, ORDER_PRODUCT_ROW_HEIGHT } from './orders.constants';

export const getAddProductRowReservedSpace = (theme: Theme) => {
  const bottomSpacing = theme.spacing(ADD_PRODUCT_ROW_BOTTOM_SPACING);

  return {
    md: `calc(${ORDER_PRODUCT_ROW_HEIGHT.md}px + ${bottomSpacing})`,
    lg: `calc(${ORDER_PRODUCT_ROW_HEIGHT.lg}px + ${bottomSpacing})`,
  };
};
